<template>
  <div class="content mx-2">
    <v-card color="transparent">
      <v-tabs
          class="pa-0 ma-0"
          background-color="#ECEEF1"
          grow
          height="50"
          hide-slider
      >
        <v-tab
            active-class="active-tab"
            class="tab"
            id="tab0"
            style="font-weight: bold !important"
            href="#mobile-tabs-5-0"
        >
          <span>Ordenar categorias</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item
            :value="0"
            class="pa-0 ma-0"
            style="background-color: #eeeeee !important"
        >
          <draggable
              class="list-group"
              tag="div"
              ghost-class="ghost"
              v-model="categories"
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
              @change="updateSortCategories"
          >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div
                  class="list-group-item d-flex"
                  v-for="(category, index) in categories"
                  :key="category.categoryId"
              >
                <strong class="mr-2 sort"> {{ index + 1 }}</strong> <span>{{ category.categoryName }} </span>
              </div>
            </transition-group>
          </draggable>
        </v-tab-item>
      </v-tabs-items>


    </v-card>

    <v-card>
      <v-row class="ma-0 py-6">
        <v-col
            cols="12"
            sm="6"
            md="6"
            lg="6"
            class="d-flex justify-lg-end justify-md-end"
        >
          <v-btn
              class="cancel-button"
              height="50"
              width="100%"
              outlined
              elevation="0"
              @click="toProductConfig()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
              class="cadaster-button"
              dark
              height="50"
              width="100%"
              elevation="0"
              @click="submitUpdateSortCategories()"
          >
            <span>Atualizar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped>
.category-name {
  background: #FFFFFF;
  padding: 20px 15px;
  margin-bottom: 5px;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
  height: 50px !important;
}

.item:active {
  background: #2d3038
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
  padding: 20px 15px;
  border: 2px solid #f5f5f5;
  background: #FFFFFF;
  list-style: none !important;
}

.sort {
  color: #bc0000 !important;
}

.cadaster-button {
  border-radius: 7.5px !important;
  transition: 0.3s;
  background: #bc0000 !important;
  font-weight: bold !important;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  font-size: 18px;
  color: #ffffff;
}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cancel-button {
  border-radius: 7.5px !important;
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-weight: bold;
  transition: 300ms;
}

.cancel-button:hover {
  background: #2d3038;
  color: white !important;
}

.cancel-button:focus {
  background: #444854;
  color: white !important;
}
.ghost{
  background: #f5f5f5;
  color: #bc0000;
}
</style>

<script>
import ApiService from "../../../../../services/ApiService";
import draggable from 'vuedraggable'
import Vue from "vue";
export default {
  name: "ProductsSortCategory",


  components: {
    draggable
  },

  data: () => ({
    apiService: new ApiService(),
    categories: [],
    activeTab: 0,
    drag: false
  }),

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  async created() {
  },

  async mounted() {
    await this.getCategories()
  },

  methods: {
    async toProductConfig() {
      await this.$router.push(
          {
            path: 'products-config',
          }
      )
    },
    async updateSortCategories() {
      this.categories.forEach((category, index) => {
        category.sort = index + 1
      })
    },

    async submitUpdateSortCategories() {
      try {
        const response = await this.apiService.post(`category/edit-sort`, this.categories)
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "success",
          title: "",
          message: response.message ? response.message : '',
          trace: null,
        });
      } catch (e) {

      }
    },

    async getCategories() {
      try {
        this.categories = await this.apiService.get(`category/list`)
        this.categories.forEach((category, index) => {
          if (!category.sort) {
            category.sort = index + 1
          }
        })
      } catch (e) {

      }
    }
  },

  watch: {},
};
</script>
